import { render, staticRenderFns } from "./ExperienceAvailabilitiesList.vue?vue&type=template&id=c28d98e0&scoped=true"
import script from "./ExperienceAvailabilitiesList.vue?vue&type=script&lang=js"
export * from "./ExperienceAvailabilitiesList.vue?vue&type=script&lang=js"
import style0 from "./ExperienceAvailabilitiesList.vue?vue&type=style&index=0&id=c28d98e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d98e0",
  null
  
)

export default component.exports